export const COLOR_MODE_STORAGE_KEY = 'intalent-color-mode'
